<template>
	<main-filter>
		<div class="filters__item filters__item--2">
			<InputSelect :label="'Статус'" :inputGray="true">
				<template #select>
					<Multiselect
						:placeholder="'Все'"
						:options="supplierStatuses"
						:label="'name'"
						:value-prop="'code'"				
						v-model="filter.status"
						ref="multiselect"
						/>
				</template>
			</InputSelect>
		</div>
		<div class="filters__item filters__item--2">
			<InputText :label="'Поиск по компании'" :placeholder="'Введите название компании'" :input-gray="true" v-model="filter.company"/>
		</div>
		<div class="filters__item filters__item--2">	
			<InputText :label="'Поиск по ИНН'" :placeholder="'Введите ИНН'" :input-gray="true" v-model="filter.inn"/>
		</div>
		<div class="filters__item filters__item--2">
			<InputText :label="'Поиск по Email'" :placeholder="'Введите Email'" :input-gray="true" v-model="filter.email"/>
		</div>
		<div class="filters__item filters__item--2">
			<InputText :label="'Поиск по телефону'" :placeholder="'Введите телефон'" :input-gray="true" v-model="filter.phone"/>
		</div>
		<div class="filters__item">
			<ProductCategories v-if="!ShowSupplierPopup" v-model="filter.productGroups" ref="productGroups"/>
		</div>
		<div class="filters__item filters__item--2">
			<div class="filters__btns">
				<button type="submint" class="btn btn--color" @click="updateSuppliers">Применить</button>
				<button class="btn btn--trans" @click="resetFilter">Сбросить фильтр</button>
			</div>
		</div>
	</main-filter>
	<div class="table-card">
		<div class="table-wrap">
			<table class="table table--default" v-if="suppliers?.items.length">
				<thead class="table__head">
				<tr class="table__row">
					<td class="table__col">№ поставщика</td>
					<td class="table__col">Ответственный менеджер</td>
					<td class="table__col">Наименование юр. лица</td>
					<td class="table__col">Товарная категория</td>
					<td class="table__col">Телефон</td>
					<td class="table__col">Статус поставщика</td>
					<td class="table__col"></td>
				</tr>
				<tr class="table__margin">
					<td colspan="100%"></td>
				</tr>
				</thead>
				<tbody v-if="suppliers" class="table__body">
				<template v-for="item in suppliers?.items" :key="item.id">
					<tr class="table__row">
						<td class="table__col">
							<span class="table__col-label">№ поставщика</span>
							<span class="table__col-cont">№{{ item.id }}</span>
						</td>
						<td class="table__col">
							<span class="table__col-label">Ответственный менеджер</span>
							<span class="table__col-cont">{{ getStringManagers(item.managers) || 'Не найдено' }}</span>
						</td>
						<td class="table__col">
							<span class="table__col-label">Наименование юр. лица</span>
							<span class="table__col-cont">{{item.legalForm?.name }} {{ item.companyName }}</span>
						</td>
						<td class="table__col">
							<span class="table__col-label">Товарная категория</span>
							<span class="table__col-cont" v-hidden-text="{height: 40, title: 'Читать дальше...'}">{{ getStringProductGroup(item.productGroups, 'name') || 'Не найдено' }}</span>
						</td>
						<td class="table__col">
							<span class="table__col-label">Телефон</span>
							<span class="table__col-cont">
								<a v-if="item.phones[0]" :href="`tel:${item.phones[0]}`">{{ `+${item.phones[0]}`}}</a>
							</span>
						</td>
						<td class="table__col table__col--status">
							<span class="status" :data-status="item.status?.name" v-html="item.status?.name"></span>
						</td>
						<td class="table__col table__col--btn">
							<div  @click="selectedSupplier = item,ShowSupplierPopup = true" class="link" >Подробнее</div>
						</td>
					</tr>
					<tr class="table__margin">
						<td colspan="100%"></td>
					</tr>
				</template>
				</tbody>
			</table>
			<div v-else class="table-card__empty">Поставщики не найдены</div>
		</div>
		<div class="pagination">
			<vue-awesome-paginate
				v-if="suppliers?.countTotal > filter.limit"
				:total-items="+suppliers?.countTotal"
				:items-per-page="filter.limit"
				:max-pages-shown="3"
				v-model="currentPage"
				:on-click="updateSuppliers" />
		</div>

		<transition name="modal">
			<SupplierPopup v-if="ShowSupplierPopup" :can-edit="['administrator', 'manager'].includes(getUserRole)" :supplier="selectedSupplier" @refreshList="this.requestSuppliers(this.filter)" @close="ShowSupplierPopup = false" />
		</transition>
	</div>
	<PageLoader v-if="isLoading"/>
</template>

<script>
import MainFilter from "@/components/blocks/MainFilter.vue";
import InputSelect from "@/components/base/utils/formElements/InputSelect.vue";
import InputText from "@/components/base/utils/formElements/InputText.vue";
import Multiselect from "@vueform/multiselect/src/Multiselect";
import SupplierPopup from "@/components/sections/Suppliers/SupplierPopup.vue";
import ProductCategories from "@/components/blocks/ProductCategories.vue";
import PageLoader from "@/components/base/utils/PageLoader.vue";
import {mapActions, mapGetters} from "vuex";


export default {
	name: "TendersTable",
	components: {
		SupplierPopup, InputSelect, MainFilter, Multiselect, ProductCategories,PageLoader, InputText
	},
	data() {
		return {
			ShowSupplierPopup: false,
			selectedSupplier: {},
			currentPage: 1,
			filter: {
				productGroups: '',
				company: '',
				inn: '',
				email: '',
				phone: '',
				offset: 0,
				limit: 10,
				status: ''
			}
		}
	},
	async created() {
		await this.requestSuppliers(this.filter)
		await this.requestSupplierStatuses()
	},
	methods: {
		getStringManagers(managers) {
			return managers?.reduce((acc,item,index) => acc += `${item}${managers.length != index + 1 ? ', ' : " "}`,'')
		},
		getStringProductGroup(group,name) {
			return group.reduce((acc,item,index) => acc += `${item[name]}${group.length != index + 1 ? ', ' : "."}`,'')
		},
		async updateSuppliers(value) {
			this.filter.offset = (value - 1) * this.filter.limit || 0
			await this.requestSuppliers(this.filter)
		},

		resetFilter() {
			this.filter.company = ''
			this.filter.inn = ''
			this.filter.email = ''
			this.filter.phone = ''
			this.$refs.multiselect.clear()
			this.$refs.productGroups.clearAll()
			this.updateSuppliers()
		},

		...mapActions({
			requestSuppliers: 'suppliers/requestSuppliers',
			requestSupplierStatuses: 'suppliers/requestSupplierStatuses',
		}),
	},

	computed: {
		...mapGetters({
			suppliers: 'suppliers/getSuppliers',
			supplierStatuses: 'suppliers/getSupplierStatuses',
			isLoading: 'isLoading',
			getUserRole: 'user/getUserRole',
		})
	}
}
</script>


